/**
 * Returns a URL that is safe to put in an `href`, or `undefined` when it is not.
 *
 * Only absolute http: and https: URLs are allowed. Everything else (javascript:, data:,
 * vbscript:, relative or protocol-relative paths, garbage) is rejected. React 17 does not
 * block `javascript:` hrefs, and values such as `partnerInfo.mapLink` come straight from the
 * public "become a partner" form, so an unchecked href is stored XSS in the admin console.
 *
 * Callers render the value as plain text (no link) when this returns `undefined`.
 */
export default function safeExternalHref(url: string | null | undefined): string | undefined {
	if (typeof url !== "string") {
		return undefined;
	}

	const trimmed = url.trim();
	if (!trimmed) {
		return undefined;
	}

	let parsed: URL;
	try {
		parsed = new URL(trimmed);
	} catch (error) {
		return undefined;
	}

	if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
		return undefined;
	}

	return parsed.href;
}
